import React, { memo, forwardRef } from "react";
const SvgLambda = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M20.244 25.142c.225.09.479.138.76.144.147.018.334.033.543.026.46-.014 1.184-.137 1.699-.747a.855.855 0 00-.086-1.18.795.795 0 00-1.146.076.39.39 0 01-.124.093 1.477 1.477 0 01-.11.004.688.688 0 01-.313-.072.641.641 0 01-.215-.24 10.408 10.408 0 01-.24-.528l-4.56-12.12c-.337-.912-.729-1.656-1.177-2.232-.431-.576-.952-1-1.56-1.272-.591-.272-1.303-.408-2.136-.408a7.23 7.23 0 00-.6.024 5.76 5.76 0 00-.551.072c-.142.014-.278.041-.407.08a2.15 2.15 0 00-1.329.912c-.247.38-.143.9.232 1.16.376.26.88.163 1.128-.218.067-.103.225-.2.507-.244.126-.02.246-.024.335-.022.006 0 .014-.01.022-.024.126-.008.259-.012.4-.012.768 0 1.383.176 1.848.528.48.352.848.88 1.104 1.584l.623 1.608-4.214 11.57a1 1 0 00.94 1.342h.102a1 1 0 00.95-.688l1.982-6.056c.209-.64.425-1.336.649-2.088.24-.752.415-1.416.527-1.992h.097c.064.256.143.56.24.912.111.352.231.728.36 1.128.143.4.28.792.407 1.176.128.368.24.696.336.984l1.896 5.352c.145.4.296.712.456.936.177.208.384.352.625.432z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgLambda.displayName = "SvgLambda";
const MemoForwardRef = memo(SvgLambda);
export default MemoForwardRef;
